import React, { useEffect, useRef, useState } from 'react';
import './ModalMessages.scss';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { createPortal } from 'react-dom';
import MessageModal from '@molecules/MessageModal/MessageModal';
import { IModalMessage } from '@molecules/ModalMessages/IModalMessage';
import { resetNotifications$ } from '@utils/notifications';
import { getMessages$, removeModalMsg } from '@utils/modalMessages';

// ----Компонент--------------------------------------------------------------------------------------------------------

const ModalMessages = () => {
    /** Флаг по которому остановить подписку */
    const obstacle = useRef<Subject<boolean>>(new Subject());

    const [sub, setSub] = useState<BehaviorSubject<IModalMessage[]> | null>(null);

    useEffect(() => {
        resetNotifications$();

        const sub = getMessages$();

        setSub(sub);
    }, []);

    /** Список уведомлений */
    const [messages, setMessages] = useState<IModalMessage[]>([]);

    // -------------------------------------------------------------------------------------------------------------------

    /** Подписываемся на список уведомлений */
    useEffect(() => {
        if (!sub || sub.closed) {
            return;
        }

        const until = obstacle.current;

        sub.pipe(takeUntil(until)).subscribe((data: IModalMessage[]) => {
            setMessages(data);
        });

        return () => {
            until.next(true);
        };
    }, [sub]);

    // -------------------------------------------------------------------------------------------------------------------
    /** Список уведомлений TSX */
    const list = messages.map((n: IModalMessage, i: number) => (
        <MessageModal key={n.id || i} item={n} remove={removeModalMsg} />
    ));

    // -------------------------------------------------------------------------------------------------------------------

    if (!list.length) {
        return null;
    }

    return createPortal(<div>{list}</div>, document.body);
};

export default ModalMessages;
